"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgPlaneSearch = function SvgPlaneSearch(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#plane-search_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 8,
    r: 5.5,
    stroke: "#17181A"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17181A",
    d: "m15 15.293-.707.707-3.949-3.949.707-.707zM9.097 6.6a.5.5 0 1 0-.707-.706l.707.707ZM5.049 8.839l-.353-.353-.707.707.353.353.707-.707Zm.396 1.81.353.354.708-.707-.354-.354-.707.707ZM8.39 5.894 4.894 9.39l.707.707L9.097 6.6l-.707-.707ZM5.6 9.39l-.55-.552-.708.707.552.552.707-.707Zm-.706.707.55.551.708-.707-.551-.551-.707.707Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.254 7.689.478-.147a.5.5 0 0 0-.338-.333l-.14.48Zm-2.48-1.245-.48-.14-.28.96.48.14.28-.96Zm2.824 4.069.147.478.956-.293-.147-.479-.956.294Zm-.204-3.304-2.62-.765-.28.96 2.62.765.28-.96Zm-.618.626.822 2.678.956-.293-.822-2.678-.956.293Z",
    fill: "#17181A"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "plane-search_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  }))));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgPlaneSearch);
var _default = exports["default"] = Memo;